import { BodilColor } from '~src/branding';
import { Loader } from '~src/components/Loader';
import { useBranding } from '~src/context/BrandingContext';
import { useDisplayContext } from '~src/context/DisplayContext';

import { IconContainer, StyledButton, StyledButtonNorlys } from './style';
import { ButtonProps, ButtonSize } from './types';

export * from './types';

export const Button = (props: ButtonProps) => {
  const { disabled, type: buttonType, onClick, ...rest } = props;

  const { isMobile } = useDisplayContext();
  const colorContext = useBranding();

  return (
    <StyledButton
      {...{ disabled, buttonType, isMobile, colorContext, ...rest }}
      onClick={disabled ? undefined : event => onClick?.(event)}
    >
      <ButtonContent {...props} />
    </StyledButton>
  );
};

export const ButtonNorlys = (props: ButtonProps) => {
  const { disabled, type: buttonType, onClick, ...rest } = props;

  return (
    <StyledButtonNorlys
      {...{ disabled, buttonType, ...rest }}
      onClick={disabled ? undefined : event => onClick?.(event)}
    >
      <ButtonContent {...props} />
    </StyledButtonNorlys>
  );
};

const ButtonContent = ({ size = 'middle', children, type, icon, ...rest }: ButtonProps) => {
  const { isLoading } = rest;
  const loaderSize = loaderDimension(size);

  return (
    <>
      {icon && <IconContainer>{icon}</IconContainer>}
      {isLoading && (
        <div style={{ position: 'absolute', left: '50%', transform: 'translate(-50%, 0)' }}>
          <Loader
            color={type === 'callToAction' ? undefined : BodilColor.base.default}
            width={loaderSize}
            height={loaderSize}
          />
        </div>
      )}
      <div style={{ visibility: isLoading ? 'hidden' : undefined }}>{children}</div>
    </>
  );
};

const loaderDimension = (size: ButtonSize) => {
  switch (size) {
    case 'small': {
      return 22;
    }
    case 'large': {
      return 36;
    }
    default: {
      return 28;
    }
  }
};
